import { useRef, useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';  // This is necessary to use RouterLink for navigation
import { alpha } from '@mui/material/styles';
import {
  Box,
  Divider,
  Typography,
  Stack,
  MenuItem,
  Avatar,
  IconButton,
} from '@mui/material';
import MenuPopover from '../../components/MenuPopover';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
// Redux
import { useDispatch } from 'react-redux';
import { setAuth } from '../../../../Redux/authSlice';
import { useDarkMode } from '../../context/DarkModeContext';

// User menu top right
const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
    linkTo: '/',
  },
  {
    label: 'Profile',
    icon: 'eva:person-fill',
    linkTo: '/profile',  // Set linkTo for profile to '/profile'
  },
  {
    label: 'Settings',
    icon: 'eva:settings-2-fill',
    linkTo: '/settings',
  },
];

export const UserAccountPopover = () => {
  const anchorRef = useRef(null);

  const [open, setOpen] = useState(null);
  const [loggedinUser, setLoggedinUser] = useState('');
  const [loggedinUserEmail, setLoggedinUserEmail] = useState('');
  const [avatar, setAvatar] = useState(''); // State for the user's avatar

  const { toggleDarkMode } = useDarkMode();
  const navigate = useNavigate();

  // Redux
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get('https://ipms.insollex.com/api/user');
        setLoggedinUser(`${data.firstName} ${data.lastName}`);
        setLoggedinUserEmail(data.emailAddress);
  
        if (data.avatar) {
          const avatarPath = data.avatar.startsWith('/static/')
            ? data.avatar
            : `/static/${data.avatar.replace(/^\/+/, '')}`;
        
          setAvatar(`https://ipms.insollex.com${avatarPath}`);
        }
      } catch (e) {
        setLoggedinUser('No one is logged in');
        setLoggedinUserEmail('Not logged in');
        
      }
    })();
  }, []);
  

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = async () => {
    setOpen(null);
  };

  const handleLogOut = async () => {
  setOpen(null);
  try {
    await axios.post('https://ipms.insollex.com/api/logout');
    toggleDarkMode(false);        // Reset dark mode on logout
    localStorage.removeItem('darkMode'); // Clear stored dark mode flag
    dispatch(setAuth(false));
    navigate('/', { replace: true });
  } catch (err) {
    console.error('Logout failed', err);
    // optionally handle error
  }
};


  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar
  src={avatar || undefined} 
  alt="User Avatar"
  sx={{ width: 40, height: 40 }}
>
  {!avatar && loggedinUser ? loggedinUser.charAt(0) : null}
</Avatar>

      </IconButton>
  
      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {loggedinUser}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {loggedinUserEmail}
          </Typography>
        </Box>
  
        <Divider sx={{ borderStyle: 'dashed' }} />
  
        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem
              key={option.label}
              to={option.linkTo}
              component={RouterLink}
              onClick={handleClose}
            >
              {option.label}
            </MenuItem>
          ))}
        </Stack>
  
        <Divider sx={{ borderStyle: 'dashed' }} />
  
        <MenuItem onClick={handleLogOut} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </MenuPopover>
    </>
  );  
};

